<style>
.v-list--dense .v-list-item{
  width: 33%;
  min-height: 50px;
  display: block;
}
.v-list--dense{
  padding: 0 !important;
}
.v-list--dense .v-item-group{
  display: flex;
}
.v-list--dense .v-list-item__icon{
  display: block;
  margin-bottom: 0px !important;
  text-align: center;

}
.v-list--dense .v-list-item__content{
  padding: 2px 2px 10px 2px !important;
  text-align: center;
}
.v-list--dense .v-list-item__title{
  font-size: .95rem !important;
  font-weight: 700 !important;
  line-height: 1.2rem !important;
}
</style>
<template>
  <div :dir="$functions.currentLangDirection()">
    <v-list dense>
      <v-list-item-group
        v-model="selectedItem"
        color="primary"
      >
        <v-list-item
          v-for="item in items"
          :key="item.keyItem"
          @click="tabClick(item.rout)"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="$t(item.text)" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import { BLink, BButton } from 'bootstrap-vue'
import Vue from 'vue'

import router from '@/router'

export default {
  components: {
    BLink, BButton,
  },
  data: () => ({
    selectedItem: 0,
    items: [
      {
        keyItem: 3, text: 'Home', icon: 'mdi-home', rout: 'home',
      },
      {
        keyItem: 1, text: 'List', icon: 'mdi-format-list-bulleted', rout: 'device-list',
      },
      {
        keyItem: 2, text: 'Dashboard', icon: 'mdi-car-speed-limiter', rout: 'dashboard',
      },
      {
        keyItem: 4, text: 'Profile', icon: 'mdi-account', rout: 'profile',
      },
    ],
  }),
  methods: {
    tabClick(rout) {
      if (rout === 'device-list') {
        this.$emit('on-update-Footer-Select', 'deviceList')

        // Vue.prototype.$footerSelected = 'deviceList'
        this.selectedItem = 1
        this.listDevice = true
        this.deviceInfoBox = false
      }
      if (rout === 'home') {
        this.$emit('on-update-Footer-Select', 'home')
        this.selectedItem = 0
        this.listDevice = false
        this.deviceInfoBox = true
      }
      if (rout === 'profile') {
        this.$emit('on-update-Footer-Select', 'profile')
        this.selectedItem = 3
      }
      /*
      if (rout === 'alertList') {
        this.$emit('on-update-Footer-Select', 'alertList')
        this.selectedItem = 2
      } */
      if (rout === 'dashboard') {
        this.$emit('on-update-Footer-Select', 'dashboard')
        this.selectedItem = 2
      }
      /// router.push({ name: rout }).catch(err => {})
    },
    monitoring() {
      router.push({ name: 'home' }).catch(err => {})
    },
  },
}
</script>
<style>

[dir=rtl] .footer .v-list-item--active .v-icon  {
  /*color: #33df5ec4 !important;*/
  /*font-size: 30px !important;*/
}

.footer .v-list--dense .v-list-item {
  min-height: unset;
}

.footer{
  bottom: 0px !important;
  position: absolute;
  width: 100%;
  border-top: 1px solid rgb(206, 206, 206);
  z-index: 99999;
  right: 0;
}
.footer-home .v-list--dense .v-list-item__title{
  font-size: .9rem !important;
  font-weight: 500 !important;
  line-height: 0.8rem !important;
  color: #828181;
}
[dir=rtl] .footer-home .v-list-item--active .v-icon,[dir=rtl] .footer-home .v-list-item--active .v-list-item__title  {
  color: #0087ff !important;
  /*font-size: 30px !important;*/
}
</style>
